<template>

  <form v-on:submit.prevent="applyDiscount">
    <div class="form-group">
      <label>Enter your voucher code</label>
      <div class="input-group">
        <input v-model="discount_code" class="form-control" required>
      <button type="submit" class="btn btn-secondary">Apply code</button>
      </div>
      <strong v-if="discount_fail">Sorry, that voucher code is not valid.</strong>
    
      <strong v-if="booking.discount" class="text-success">Voucher valid - your discount has been applied.</strong>
    </div>
  </form>

</template>

<script>
import axios from 'axios';

export default {
  name: 'Discount',
  props: {
    booking: Object,
    passengerCount: Number
  },
  data () {
    return {
      loading: false,
      discount_code: null,
      discount_fail: false
    }
  },
  methods: {
    applyDiscount() {
      // console.log(this.$root.instance.departure_date)
      // console.log(this.$parent)
      this.loading = true
      this.booking.discount = null
      this.discount_fail =  false,
      axios.post(this.$root.$api + 'discounts/validate', {
        discount_code: this.discount_code,
        booking: this.$root.tour.id,
        tour_id: this.$root.tour.id,
        departure_date: this.$root.instance.departure_date
        // departure_date: this.instance.departure_date
      })
      .then(res => res.data)
      .then(response => { 
        this.loading = false
        if(response.success) {
          this.discount_fail = false
          this.booking.discount = response.data
        } else {
          this.discount_fail = true
        }
      })
      .catch(error => {
        this.loading = false
        this.discount_fail = true
        console.log(error.message);
      })
    },
  }
}
</script>
